var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21 16",
    style: {
      enableBackground: "new 0 0 21 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st1{fill:#FFFFFF;}\n\t.st2{mask:url(#b_1_);fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 0.9,
    y: 0.5,
    width: 19.2,
    height: 14.9
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0.9,
    y: 0.5,
    width: 19.2,
    height: 14.9,
    id: "b_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a_1_",
    className: "st1",
    d: "M0.9,0.5h19.2v14.9H0.9V0.5z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M19.9,3.7c0,0-0.2-1.5-0.8-2.1c-0.7-0.8-1.6-0.8-1.9-0.9c-2.7-0.2-6.7-0.2-6.7-0.2h0c0,0-4,0-6.7,0.2 C3.4,0.8,2.6,0.8,1.8,1.6C1.3,2.2,1.1,3.7,1.1,3.7S0.9,5.4,0.9,7.1v1.6c0,1.7,0.2,3.4,0.2,3.4s0.2,1.5,0.8,2.1 c0.7,0.8,1.7,0.8,2.1,0.9c1.5,0.2,6.5,0.2,6.5,0.2s4,0,6.7-0.2c0.4,0,1.2-0.1,1.9-0.9c0.6-0.6,0.8-2.1,0.8-2.1s0.2-1.7,0.2-3.4V7.1 C20.1,5.4,19.9,3.7,19.9,3.7L19.9,3.7z M13.7,7.7l-5.2,3l0-4.6V4.7l2.3,1.3L13.7,7.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.9efe81d102560deb3fac5772663b19e4.svg";
export { ForwardRef as ReactComponent };